import {
  Box,
  buildPath,
  buildTemplatePath,
  Card,
  Link,
  Page,
  PageRoute,
  Stack,
  Tooltip,
  Typography,
} from "@compass/core";
import { Home, LkHomeDashboardId } from "generated/openApi";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import ApiService from "services/apiService";
import { MatchDashboard } from "./MatchDashboard/MatchDashboard";
import { ServiceDashboard } from "./ServiceDashboard/ServiceDashboard";

const routeName = "home";

export const homePageRoute: PageRoute = {
  handle: "Home",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const HomePage = () => {
  const [home, setHome] = useState<Home>({} as Home);
  const appRolePermissions = useSelector((state: RootState) => state.app.rolePermissions);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = () => {
    ApiService.home.get().then((response) => {
      setHome(response);
    });
  };

  const displayDashboard = (id: number) => home.dashboards?.find((x) => x.id === id);

  return (
    <Page>
      <Stack direction="column" spacing="lg">
        <Card>
          <Stack direction="row" justifyContent="space-between" alignItems={"center"}>
            <Stack direction="column" spacing="sm">
              <Typography variant="h4">Welcome, {home?.userFirstName}</Typography>
              {/* <Typography variant="h5" fontWeight="normal">
                Access level: {home?.role}
              </Typography> */}
            </Stack>

            <Box>
              <Tooltip
                title={
                  <Box>
                    <Box>Compass works best with Chrome browser.</Box>
                    <Box>
                      Go to{" "}
                      <Link href="https://www.google.com/chrome/" target="_blank" color="inherit">
                        https://www.google.com/chrome/
                      </Link>{" "}
                      to download
                    </Box>
                  </Box>
                }
              >
                <img height="50px" src="browser-chrome-icon.png" />
              </Tooltip>
            </Box>
          </Stack>
        </Card>

        {displayDashboard(LkHomeDashboardId.Service) && <ServiceDashboard />}

        {displayDashboard(LkHomeDashboardId.Match) && <MatchDashboard />}
      </Stack>
    </Page>
  );
};
